import * as React from 'react';
import DotGridOutlined from './dot-grid-outlined';
import DotGridFilled from './dot-grid-filled';
import type { IconCombinedProps } from './types';
const DotGridCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <DotGridFilled ref={ref} {...rest} />;
  }
  return <DotGridOutlined ref={ref} {...rest} />;
});
export default DotGridCombined;